// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Static_XML_to_HTML = require("./Static_XML_to_HTML.res.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;

var exampleFormattedText = "\n<h1>This is Heading1</h1>\n<h2>This is Heading2</h2>\n<h3>This is Heading3</h3>\n<h4>This is Heading4</h4>\n<h5>This is Heading5</h5>\n<h6>This is Heading6</h6>\nThis is a hyperlink -> <a font-weight=\"bold\" color=\"green\" href=\"https://us.metamath.org\">Metamath</a>.\n<hr/>\nText may be separated by horizontal lines.\n<hr/>\nText may be <b>bold</b>, <i>italic</i>, <span font-family=\"monospace\" font-size=\"1.25em\">monospace</span>, \nit may have <span font-size=\"0.6em\">different</span> <span font-size=\"1.5em\">sizes</span>\nand <span color=\"blue\">different</span> <span color=\"red\">colors</span>.\n\n<p>Long chunks of text may be grouped into paragraphs.</p>\n\n<ul>\n    <li>This is an unordered list</li>\n    <li>item2</li>\n    <li>item3</li>\n</ul>\n\n<ol>\n    <li>This is an ordered list</li>\n    <li>item2</li>\n    <li>item3</li>\n</ol>\n\n<table>\n    <tbody>\n        <tr><td>This</td><td>is</td></tr>\n        <tr><td>a</td><td>table</td></tr>\n    </tbody>\n</table>\n\n<p>Monospaced multiline text:</p>\n<pre>--- 2p3e5 -----------------------------\n1|       | 3cn      | |- 3 e. CC\n2|       | 2cn      | |- 2 e. CC\n3|       | 3p2e5    | |- ( 3 + 2 ) = 5\n4| 1,2,3 | addcomli | |- ( 2 + 3 ) = 5\n---------------------------------------</pre>\n";

function XML_formatting_help(props) {
  var onClose = props.onClose;
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, React.createElement(Button, {
                            onClick: (function (param) {
                                onClose();
                              }),
                            variant: "contained",
                            children: "Close"
                          }), React.createElement(Paper, {
                            style: {
                              padding: "10px"
                            },
                            children: Caml_option.some(React.createElement(Static_XML_to_HTML.make, {
                                      xmlStr: exampleFormattedText
                                    }))
                          }), React.createElement(Paper, {
                            style: {
                              padding: "10px"
                            },
                            children: Caml_option.some(React.createElement("pre", undefined, exampleFormattedText))
                          }), React.createElement(Button, {
                            onClick: (function (param) {
                                onClose();
                              }),
                            variant: "contained",
                            children: "Close"
                          })))
            });
}

var make = XML_formatting_help;

exports.exampleFormattedText = exampleFormattedText;
exports.make = make;
/* react Not a pure module */
